/**
 * Lista de observações acumuladas (a mais antiga primeiro), já quebradas pelo backend.
 *
 * Duas apresentações: `compact`, a caixa com rolagem que fica acima de um campo de texto para quem
 * vai acrescentar uma observação; e `block`, os parágrafos de leitura de um modal de detalhes, que
 * preservam as quebras de linha digitadas.
 */
interface Props {
    notes: string[];
    /** nome acessível da lista */
    label: string;
    variant?: 'compact' | 'block';
    /** o que mostrar sem observação; sem ele, nada é renderizado */
    emptyText?: string;
}

const LIST_CLASS = {
    compact: 'max-h-28 overflow-y-auto border dark:border-slate-600 rounded divide-y dark:divide-slate-600 text-xs',
    block: 'space-y-1',
};

const ITEM_CLASS = {
    compact: 'px-2 py-1 text-gray-600 dark:text-gray-300',
    block: 'font-medium whitespace-pre-wrap break-words',
};

const NotesList: React.FC<Props> = ({ notes, label, variant = 'compact', emptyText }) => {
    if (!notes || notes.length === 0) {
        return emptyText ? <p className={ITEM_CLASS[variant]}>{emptyText}</p> : null;
    }
    return (
        <ul aria-label={label} className={LIST_CLASS[variant]}>
            {notes.map((note, i) => (
                <li key={`${i}-${note}`} className={ITEM_CLASS[variant]}>{note}</li>
            ))}
        </ul>
    );
};

export default NotesList;
